import React from "react";
import Dashboard from "./Dashboard";
import SidebarLayout from "../Components/sidebar/SidebarLayout";

function Listen() {
  return (
    <>
      <SidebarLayout>
        <div style={{ position: "relative" }}>
          <Dashboard />
        </div>
      </SidebarLayout>
    </>
  );
}

export default Listen;
